import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoicePDF from "./InvoicePDF";

export default function InvoiceDownloadButton({ order }) {
  
  return (
    <PDFDownloadLink className="downPdf"
      document={<InvoicePDF order={order} />}
      fileName={`invoice-${order.data.id}.pdf`}
    >
      {({ loading }) => (loading ? "در حال ساخت فاکتور..." : "دریافت فاکتور")}
    </PDFDownloadLink>
  );
}
